var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalServico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.352,
    height: 12.462,
    viewBox: "0 0 18.352 12.462",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-5.824 -8.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1",
    "data-name": "Caminho 1",
    d: "M19.172,19.409l5,1.409-4.63-6.931-2.266-.154Z",
    fill: "#9ed36b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2",
    "data-name": "Caminho 2",
    d: "M5.824,20.818l5-1.415.909-2.729.987-2.944-1.935.13-.336.023-.046.076Z",
    fill: "#b3df80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3",
    "data-name": "Caminho 3",
    d: "M10.832,19.411l4.045,1.759.145.061,1.093-.482.206-.092,2.844-1.246L17.278,13.73H12.721l-.979,2.951v.008Z",
    fill: "#b3df80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4",
    "data-name": "Caminho 4",
    d: "M14.877,21.17l.145.061,1.094-.482.206-.092-1.3-.275Z",
    fill: "#b3df80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5",
    "data-name": "Caminho 5",
    d: "M10.832,19.411l4.19,1.82v-.91l-.008-3.273-.008-.359L15,13.73H12.721l-.979,2.951v.008l-.184.543Z",
    fill: "#9ed36b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_6",
    "data-name": "Caminho 6",
    d: "M17.722,11.537v.031a2.771,2.771,0,0,1-.237,1.086,1.631,1.631,0,0,1-.153.306L15,16.851l-.008.015-2.4-3.861a2.838,2.838,0,0,1-.413-1.468,2.772,2.772,0,0,1,2.768-2.768H15a2.773,2.773,0,0,1,2.722,2.768Z",
    fill: "#fc8370"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7",
    "data-name": "Caminho 7",
    d: "M16.285,11.422A1.327,1.327,0,0,1,15,12.753a.13.13,0,0,1-.054.008,1.334,1.334,0,1,1,0-2.669A.13.13,0,0,1,15,10.1,1.32,1.32,0,0,1,16.285,11.422Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8",
    "data-name": "Caminho 8",
    d: "M17.722,11.537v.031a2.771,2.771,0,0,1-.237,1.086,1.631,1.631,0,0,1-.153.306L15,16.851v-4.1A1.327,1.327,0,0,0,15,10.1V8.769a2.773,2.773,0,0,1,2.722,2.768Z",
    fill: "#e7553c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_9",
    "data-name": "Caminho 9",
    d: "M16.285,11.422A1.327,1.327,0,0,1,15,12.753V10.1A1.32,1.32,0,0,1,16.285,11.422Z",
    fill: "#e4e8eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalServico);
export default __webpack_public_path__ + "static/media/local-servico.3234d85c9074ace1f778218a6544626d.svg";
export { ForwardRef as ReactComponent };